// Countries whose fiscal device management has migrated to Fiskaly (via Hydra/pay-fiscal).
// Germany currently manages this via the legacy TSE integration (see views/tss) and will
// move here later - add 'DE' once that migration happens.
//
// Note: the TSS view intentionally still has its own local modal/search form rather than
// the shared components in @tills/components (confirmActionModal, infoCard,
// serialNumberSearchForm) that this Tills decommission view uses. TSS and Tills decommission
// hit different backends (REST/TSE vs GraphQL/Hydra), so unifying the UI now would mean a QA
// regression pass on a live production feature for no behavioural change, and would make two
// distinct services look identical before they actually are one. When DE migrates here, TSS
// gets retired wholesale rather than incrementally converted, so it'll pick up the shared
// components for free at that point - no need to backport them beforehand.
export const TILLS_DECOMMISSION_COUNTRIES = ['FR'];
